import { NutritionVersionService } from "@omnia/shared/nutrition/version/service";
import { getMainCropForNmaxGroup, getManureSpreadableArea, isCropIgnoredForNutrition, isCropSupportedForNutrition } from "../shared/nutrition";
import { getHorizontalBarBackgroundStyle, getNutrientBaseColor, getNutrientColorProvider, getNutrientHorizontalBarBackgroundStyle, nutrientColors } from "../shared/nutrition/colors";
import { setBaseLayerStyle } from "../shared/nutrition/map/baseLayerStyle"
import { NutrientAppLayer } from "../shared/nutrition/map/nutrientAppLayer";
import { NutrientAppLayerViewerFactory } from "../shared/nutrition/map/nutrientAppLayerViewer";
import { NutrientAppZone } from "../shared/nutrition/map/nutrientAppZone";
import { RequirementsLayer } from "../shared/nutrition/map/requirementsLayer";
import { RequirementsLayerViewerFactory } from "../shared/nutrition/map/requirementsLayerViewer";
import { RequirementsZone } from "../shared/nutrition/map/requirementsZone";

export const nutrition = {

    getManureSpreadableArea,
    isCropSupportedForNutrition,
    isCropIgnoredForNutrition,
    getMainCropForNmaxGroup,

    NutritionVersionService,

    colors: {
        nutrientColors,
        getHorizontalBarBackgroundStyle,
        getNutrientHorizontalBarBackgroundStyle,
        getNutrientColorProvider,
        getNutrientBaseColor
    },

    map: {
        setBaseLayerStyle,
        NutrientAppLayer,
        NutrientAppZone,
        RequirementsZone,
        RequirementsLayer,
        RequirementsLayerViewerFactory,
        NutrientAppLayerViewerFactory
    }
}
